import { useEffect } from "react";

const HEAP_CUSTOM_PAGE_VIEW_EVENT = "View Page - Page View - New View Page";

const useExternalViewPageTracking = ({ content }) => {
  const { id: contentId, content_type: contentType } = content || {};

  useEffect(() => {
    if (contentId && contentType) {
      window?.heap?.track(HEAP_CUSTOM_PAGE_VIEW_EVENT, {
        content_type: contentType,
        content_id: contentId,
      });
    }
  }, [contentId, contentType]);
};

export default useExternalViewPageTracking;
